import { useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";

import styles from "./Cards.module.css";

const calendarData = [
    {
        id: "abstract",
        event: "Submission of Abstract",
        date: "November 10, 2026",
    },
    {
        id: "notification",
        event: "Notification of Acceptance",
        date: "December 28, 2026",
    },
    {
        id: "compliant",
        event: "IEEE-Compliant Abstract Due",
        date: "January 14, 2027",
    },
    {
        id: "earlybird",
        event: "Early Bird Registration",
        date: "January 31, 2027",
    },
];

// One accent colour per card, cycled by index.
const accentColors = ["#1d63c7", "#0ea5e9", "#16a34a", "#d97706"];

/**
 * Renders the calendar-of-events data as one animated,
 * colour-coded row of cards (in place of a plain table).
 */
const CalendarCards = () => {
    const [filter, setFilter] = useState("all");

    const items =
        filter === "all"
            ? calendarData
            : calendarData.filter((item) => item.id === filter);

    return (
        <>
            <select
                className={styles.customSelect}
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
            >
                <option value="all">Show Complete Timeline</option>

                {calendarData.map((item) => (
                    <option key={item.id} value={item.id}>
                        {item.event}
                    </option>
                ))}
            </select>

            <div className={styles.cardRow}>
                {items.map((item, index) => (
                    <div
                        key={item.id}
                        className={styles.eventCard}
                        style={{
                            "--accent": accentColors[index % accentColors.length],
                            animationDelay: `${index * 0.08}s`,
                        }}
                    >
                        <div className={styles.eventCardIcon}>
                            <FaCalendarAlt />
                        </div>

                        <span className={styles.eventCardLabel}>
                            {item.event}
                        </span>

                        <strong className={styles.eventCardDate}>
                            {item.date}
                        </strong>
                    </div>
                ))}
            </div>
        </>
    );
};

export default CalendarCards;